<template>
    <div>
        <form>
            <FormGroupNew :label="__('sale.shipping')"
                          :description="__('actions.determine_whether_to_enable_shipping')"
                          :error="value.errors.shipping_active"
                          required
            >
                <Checkbox v-model="localForm.shipping_active"
                          :disabled="youbuydaTosWasNotAccepted"
                >
                    {{ __('actions.enable_thing', {thing: __('sale.shipping')}) }}
                </Checkbox>
            </FormGroupNew>

            <div class="row">
                <div class="col-md-6">
                    <FormGroupNew :label="__('general.shipping_cost')"
                                  :description="__('general.tax_included')"
                                  :error="value.errors['shipping_cost.amount']"
                                  required
                    >
                        <input type="number"
                               v-model="localForm.shipping_cost.amount"
                               class="form-control"
                               step="0.01"
                               :placeholder="__('sale.free_shipping')"
                               :disabled="youbuydaTosWasNotAccepted || !localForm.shipping_active"
                        >
                    </FormGroupNew>
                </div>
                <div class="col-md-6">
                    <FormGroupNew :label="__('general.shipping_tax_rate')"
                                  :description="__('sale.vat_rate_description')"
                                  :error="value.errors['shipping_cost.tax_rate']"
                                  required
                    >
                        <input type="number"
                               v-model="localForm.shipping_cost.tax_rate"
                               class="form-control"
                               step="0.01"
                               placeholder="0.00"
                               :disabled="youbuydaTosWasNotAccepted || !localForm.shipping_active"
                        >
                    </FormGroupNew>
                </div>
            </div>

            <FormGroupNew
                v-if="hasStripeAccount"
                :label="__('sale.stripe_shipping_id')"
                :error="value.errors.stripe_rate_id"
                :warning="!value.stripe_rate_id"
                :required="hasStripeAccount"
            >
                <div class="input-icon input-icon-right">
                    <input type="text"
                           v-model="localForm.stripe_rate_id"
                           class="form-control"
                           required
                           placeholder="shr_xxxxxxxxxxxxxxxxxxxxxxx"
                           :disabled="!stripeIsReady"
                    >
                    <span class="cursor-pointer"
                          data-placement="bottom"
                          data-trigger="click"
                          data-toggle="tooltip"
                          data-html="true"
                          :title="__('sale.stripe.shipping_info')"
                    >
                          <i class="fa fa-info-circle icon-md"/>
                    </span>
                </div>
            </FormGroupNew>
        </form>
    </div>
</template>

<script>
import FormGroup from '@components/Form/FormGroup.vue'
import { Link } from '@inertiajs/vue2';
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import Checkbox from "@components/Form/Checkbox.vue";

export default {
    components: {Checkbox, SaveAndEnableButton, FormGroupNew, FormGroup, Link},

    props: {
        tosAccepted: Boolean,
        storeUuid: String,
        hasStripeAccount: Boolean,
        stripeIsReady: Boolean,
        value: Object
    },

    data() {
        return {
            localForm: this.value
        }
    },

    computed: {
        youbuydaTosWasNotAccepted() {
            return !this.tosAccepted
        },
    },

    watch: {
        localForm: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
